module.exports = __webpack_public_path__ + "img/9pica.50caac18.png";